import css from './sass/style.scss';

//require('./js/polyfills.js');
require('./js/init.js');
require('./js/helpers.js');
require('./js/ismobile.js');
require('./js/carousels.js');
require('./js/gototarget.js');
require('./js/inview.js');
require('./js/parallax.js');
//require('./js/fixel.js');
//require('./js/scrollpos.js');

//require('./js/nav.js');
require('./js/splitting.js');


require('./img/products/top.png');
require('./img/products/top@2x.png');
require('./img/products/step-01.png');
require('./img/products/step-01@2x.png');
require('./img/products/step-02.png');
require('./img/products/step-02@2x.png');
require('./img/products/step-03.png');
require('./img/products/step-03@2x.png');
require('./img/products/step-04.png');
require('./img/products/step-04@2x.png');
require('./img/products/step-05.png');
require('./img/products/step-05@2x.png');